
import { Configure2faResponse } from 'Hooks/Api/apiAccount';
import React, { createContext } from 'react';


export type InitialSetupArguments = {
	userName: string,
	loggedInUserName?: string,
	configurePromise: Promise<Configure2faResponse>,
	close: (dataUnchanged?: boolean) => void,
	// % protected region % [Add any extra InitialSetupArguments fields here] off begin
	// % protected region % [Add any extra InitialSetupArguments fields here] end
};

export type RemoveArguments = {
	userName: string,
	close: (dataUnchanged?: boolean) => void,
	// % protected region % [Add any extra RemoveArguments fields here] off begin
	// % protected region % [Add any extra RemoveArguments fields here] end
};

export type LoginArguments = {
	onTwoFactorSuccess?: () => void,
	rememberMe?: boolean,
	// % protected region % [Add any extra LoginArguments fields here] off begin
	// % protected region % [Add any extra LoginArguments fields here] end
}

export type TwoFactorResponse = {
	content: React.ReactNode,
	required: boolean,
	// % protected region % [Add any extra TwoFactorResponse fields here] off begin
	// % protected region % [Add any extra TwoFactorResponse fields here] end
}

export interface TwoFactorConfiguration {
	onInitialSetup: (args: InitialSetupArguments) => TwoFactorResponse;
	onRemove: (args: RemoveArguments) => TwoFactorResponse;
	onLogin: (args: LoginArguments) => TwoFactorResponse;
	// % protected region % [Add any extra TwoFactorConfiguration fields here] off begin
	// % protected region % [Add any extra TwoFactorConfiguration fields here] end
}

export interface TwoFactorMethods {
	[name: string] : TwoFactorConfiguration;
	// % protected region % [Add any extra TwoFactorMethods fields here] off begin
	// % protected region % [Add any extra TwoFactorMethods fields here] end
}

// % protected region % [Customise buildOtpUrl here] off begin
export const TwoFactorContext = createContext<TwoFactorMethods>({ });
// % protected region % [Customise buildOtpUrl here] end


